$(function () {
    var preselectTimeout = null;

    $('.preselect').on("actuallyMissing", function (e) {
        play('soundWarningQuickselect');

        $('.preselect-message').text('Nincs ilyen elem a listában.')
    });
    $('.preselect').on("keydown", ".preselector", function (e) {
        if (e.which == 13) {
            try {
                $('.preselect-message').text('').clearQueue().show()

                var key = $(this).val();
                var $cb = $(
                    '.item-' + key +
                    ', .item-' + (key.substr(0, key.length - 4)) +
                    ', .item-' + (key).replace(/^0+/, '') +
                    ', .item-' + (key.substr(0, key.length - 4)).replace(/^0+/, '')
                );
                var $row = $cb.parents('tr');
                var msg = '';

                if ($row.length && $cb.is(':checked')) {
                    $('.preselect-message').text(msg = 'Elem már ki lett választva.')
                    play('soundWarningQuickselect')

                } else if (!$row.length) {
                    if ($('.preselect').data('handle-missing')) {
                        $('.preselect').trigger('missing-action', key);
                        msg = 'handle-custom';
                    } else {
                        $('.preselect-message').text(msg = 'Nincs ilyen elem a listában.')
                        play('soundWarningQuickselect')

                    }
                } else {
                    $cb.prop('checked', true).trigger('futar:checked')

                    $('.preselect-val').each(function () {
                        $row.find($(this).data('preselect')).val($(this).val())
                    })
                    msg = 'ok';

                    putRowAfterLastSelection($row)
                }
                $.post('/admin/orders/' + key + '/barcode-log', {
                    'reason': 'Checkbox beolvasás (' + msg + ')',
                    '_token': $('meta[name="csrf-token"]').attr('content')
                });

                $(this).val('');
            } catch (e) {
                console.error(e);
            }

            if (preselectTimeout) {
                clearTimeout(preselectTimeout)
            }
            preselectTimeout = setTimeout(function () {
                $('.preselect-message').fadeOut(500);
                preselectTimeout = null;
            }, 2000);

            e.preventDefault();
            return false;
        }
    });

    function putRowAfterLastSelection($row) {
        $row.siblings('tr').has('input[type=checkbox][checked]').not($row).last().after($row);
    }
})


var waitforplay = {};

function play(el) {
    var $el = $('#' + el);
    if ($el.length) {
        if (waitforplay[el]) return;
        waitforplay[el] = true;
        $el.get(0).currentTime = 0;
        $el.get(0).play().then(() => waitforplay[el] = false);
    }
}
